import React, { useEffect, useState } from 'react';

import { headersVinculo, VinculoTableRow } from './auxiliarVinculoUsuario';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../components/BoxConteudo';
import { CustomSwal } from '../../../components/CustomFeedback/CustomSwal';
import CustomOffcanvas from '../../../components/CustomOffcanvas';
import CustomTable from '../../../components/CustomTable';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import { getUser } from '../../../modules/contexts/Auth/RequireAuth';
import {
  UserVinculoToken,
  UsuarioVinculo,
} from '../../../modules/types/UsuarioVinculo';
import { getUsuarioVinculosByUsuarioId } from '../../../services/usuario/usuarioVinculoService';
import { formatDateSimp, getDominioOptions } from '../../../utils/functions';
import { handleDelete } from '../../../utils/handleDelete';
import { handleSave } from '../../../utils/handleSave';
import { swal } from '../../../utils/swal';
import FormVinculacaoUsuario from '../components/formVinculacaoUsuario';

interface VinculoUsuarioListagemProps {
  fichaID: string;
  onRefreshData?: () => void;
}

const VinculoUsuarioListagem: React.FC<VinculoUsuarioListagemProps> = ({
  fichaID,
  onRefreshData,
}) => {
  const pageMeusDados = window.location.hash.includes('meusdados');

  const user = getUser();
  const isSuperAdmin =
    Array.isArray(user?.vinculo) &&
    (user.vinculo as UserVinculoToken[]).some(
      (v) => v.superAdmin === true && v.status === 'Ativo',
    );
  const userID = user.sub;
  const [vinculos, setVinculos] = useState<UsuarioVinculo[]>([]);
  const [idVinculo, setIdVinculo] = useState(0);
  const [showOffCanvas, setShowOffCanvas] = useState<boolean>(false);
  const handleOffCanvas = () => setShowOffCanvas((prev) => !prev);

  const handleCloseOffCanvas = () => {
    handleOffCanvas();
  };
  const [titleOffcanvas, setTitleOffcanvas] = useState('');

  const handleInserirVinculacao = () => {
    setIdVinculo(0);
    handleOffCanvas();
    setTitleOffcanvas('Adicionar Vínculo de Usuário');
  };
  const fetchVinculos = async () => {
    try {
      const userVinculosData = await getUsuarioVinculosByUsuarioId(
        parseInt(fichaID, 10),
      );
      setVinculos(userVinculosData);
    } catch (error) {
      console.error('Erro ao buscar vínculos do usuário:', error);
    }
  };
  useEffect(() => {
    if (fichaID) {
      fetchVinculos();
    }
  }, [fichaID]);

  const handleRefreshData = () => {
    fetchVinculos();
    onRefreshData?.();
  };

  const hasVinculacaoAtiva = vinculos.some(
    (vinculo) => !vinculo.status || String(vinculo.status.nome) === 'Ativo',
  );
  const tableData: VinculoTableRow[] = vinculos.map((item) => {
    return {
      id: item?.id ?? 'Não informado',
      status: item.status ? item.status.nome : 'Pendente',
      nuSolicitacao: item.nuSolicitacao.label,
      interface: item.interface.nome,
      papel: item.papel ? item.papel.nome : 'Não informado',
      setor: item.interfaceVinculo,
      dataInicio: formatDateSimp(item.dataInicio),
      dataFim: item.dataTermino ? formatDateSimp(item.dataTermino) : '-',
    };
  });

  const handleTableRowClick = (row: any) => {
    setIdVinculo(row.id);
    handleOffCanvas();
    setTitleOffcanvas('Editar Vínculo de Usuário');
  };

  const camposAjustar = {
    number: [
      'status',
      'nuSolicitacao',
      'nuInterface',
      'papelId',
      'interfaceVinculo',
      'interfaceId',
    ],
    string: ['dataInicio', 'dataTermino', 'observacao'],
  };
  const handleInativarVinculo = (id: number) => {
    CustomSwal.show({
      title: 'Atenção',
      html: 'Deseja realmente remover este vínculo?',
      type: 'warning',
      confirmText: 'Sim, remover',
      cancelText: 'Cancelar',
      onConfirm: async () => {
        try {
          const vinculo = vinculos.find((v) => v.id === id);
          const vinculoId = vinculo?.id;
          if (!vinculoId) {
            swal('error', 'Erro', 'ID do vínculo não encontrado.');
            return;
          }
          await handleDelete(
            vinculoId,
            'usuario-vinculos/inativar',
            '',
            undefined,
            undefined,
            false,
            fichaID,
            fetchVinculos,
            {
              title: 'Vínculo Removido!',
              html: '<span style="font-size: 1.45rem;">O vínculo foi <b>removido</b> com sucesso!</span>',
            },
          );

          const handleLogout = () => {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            window.location.href = '/';
          };
          userID !== fichaID ? handleRefreshData() : handleLogout();
        } catch (error) {
          console.error('Erro ao remover vínculo:', error);
          swal('error', 'Erro', 'Não foi possível remover o vínculo.');
        }
      },
    });
  };

  const handleAtivarVinculo = (id: number) => {
    CustomSwal.show({
      title: 'Atenção',
      html: 'Deseja realmente aprovar este vínculo?',
      type: 'warning',
      confirmText: 'Sim, aprovar',
      confirmButtonColor: '#2e7d32',

      onConfirm: async () => {
        try {
          const vinculo = vinculos.find((v) => v.id === id);
          if (!vinculo) return;

          const optionsStatus = getDominioOptions(12);
          const statusAtivo = optionsStatus.find((op) => op.label === 'Ativo');

          if (!statusAtivo) {
            swal('error', 'Erro', 'Status Ativo não encontrado.');
            return;
          }

          const dadosVinculo = {
            ...vinculo,
            usuarioId: Number(fichaID),
            interfaceId: vinculo.interface?.id,
            nuInterface: vinculo.interface?.id,
            nuSolicitacao: vinculo.nuSolicitacao?.value,
            papelId: vinculo.papel?.id,
            interface: vinculo.interface?.nome,
            interfaceVinculo:
              (vinculo.interfaceVinculo as any)?.value ??
              vinculo.interfaceVinculo,
            status: statusAtivo.value,
            dataTermino: null,
          };

          const camposObrigatoriosAtivacao = {
            status: 'Status',
          };

          handleSave(
            dadosVinculo,
            camposObrigatoriosAtivacao,
            camposAjustar,
            'usuario-vinculos/ativar',
            '',
            handleRefreshData,
          );
        } catch (error) {
          console.error('Erro ao aprovar vínculo:', error);
          swal('error', 'Erro', 'Não foi possível aprovar o vínculo.');
        }
      },
    });
  };
  // headers
  const headers = [
    ...headersVinculo,
    {
      text: 'Ação',
      width: 5,
      key: 'acao',
      renderCell: (id: any, row: any) => {
        const isAtivo = row.status === 'Ativo';
        const isPendente = row.status === 'Pendente';

        if (isPendente) {
          return (
            <div style={{ textAlign: 'center' }}>
              <span
                className="material-icons"
                style={{
                  cursor: 'pointer',
                  color: '#2e7d32',
                  fontSize: '1.8rem',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAtivarVinculo(Number(row.id));
                }}
                title="Ativar vínculo"
              >
                check_circle
              </span>
            </div>
          );
        }

        return (
          <div style={{ textAlign: 'center' }}>
            <span
              className="material-icons"
              style={{
                cursor: isAtivo ? 'pointer' : 'default',
                color: isAtivo ? '#d32f2f' : '#818181',
                fontSize: isAtivo ? '1.8rem' : '1.4rem',
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (isAtivo) handleInativarVinculo(Number(row.id));
              }}
              title={
                isAtivo
                  ? 'Remover vínculo'
                  : 'Vínculo inativo (ação indisponível)'
              }
            >
              {isAtivo ? 'cancel' : 'lock'}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <BoxConteudo boxTitulo="Vínculos do Usuário">
      <CustomTable
        headers={headers}
        data={tableData}
        onRowClick={handleTableRowClick}
        showIconOffcanvas={false}
        showPagination={false}
      />
      {!pageMeusDados && (
        <BarraInferiorBotoes>
          {/* Botão de Inserir Vinculação */}

          {isSuperAdmin && (
            <div style={{ opacity: hasVinculacaoAtiva ? 0.5 : 1 }}>
              <WorkspaceBotoes
                inserir
                onClickInserir={() => {
                  const vinculoAtivo = vinculos.find(
                    (v) => v.status && String(v.status.nome) === 'Ativo',
                  );

                  if (vinculoAtivo) {
                    CustomSwal.show({
                      title: 'Já existe um vínculo ativo.',
                      html: 'Não é possível adicionar outro.',
                      type: 'warning',
                      confirmText: 'OK',
                    });
                  } else if (hasVinculacaoAtiva) {
                    CustomSwal.show({
                      title: 'Solicitação Pendente',
                      html: 'Este usuário já possui uma solicitação de vínculo pendente.',
                      type: 'warning',
                      confirmText: 'OK',
                    });
                  } else {
                    handleInserirVinculacao();
                  }
                }}
              />
            </div>
          )}
        </BarraInferiorBotoes>
      )}
      {/* 🔹 OffCanvas de novo registro */}
      <CustomOffcanvas
        show={showOffCanvas}
        onClose={handleCloseOffCanvas}
        title={titleOffcanvas}
        width="60vw"
        showOpenButton={false}
      >
        {/* Aqui vai o conteúdo do novo registro */}
        <FormVinculacaoUsuario
          fichaID={Number(fichaID)}
          idVinculo={idVinculo}
          onRefreshData={handleRefreshData}
        />
      </CustomOffcanvas>
    </BoxConteudo>
  );
};

export default VinculoUsuarioListagem;
